// Services
import { compareDates } from './General';

// Interfaces
import { PhysiologicalMonitoring, DataElement, PhysiologicalDataCase } from '../interfaces/PhysiologicalMonitoring';
import { PollValues } from '../interfaces/Poll';

// Other
import moment from 'moment';
import { OTHER_FC_EKG } from '../data/ConstantsPatient';

const valueOrNull = (value: number | undefined | null) => {
    return value === undefined || value === null ? null : Number(value);
};

export const parsePhysiologicalMontioring = (physiological: PhysiologicalMonitoring[], inquiriy_answers: PollValues[]): DataElement[] => {
    inquiriy_answers.forEach(pollValue => {
        const filledDate = moment(pollValue.date).locale('es');
        const assignedDate = pollValue.assigned_inquiry?.filled_date ? moment(pollValue.assigned_inquiry?.filled_date).locale('es') : null;
        const date = assignedDate === null || (filledDate.day() === assignedDate.day() && filledDate.month() === assignedDate.month() && filledDate.year() === assignedDate.year())
            ? filledDate
            : assignedDate;

        const transformElement: PhysiologicalMonitoring = {
            sheet_parameter_id: pollValue.answer?.question?.sub_category ?? pollValue.answer?.id?.toString(),
            ...pollValue.answer?.question?.inquiry_question_type_id === 1 && pollValue.answer?.value !== null
                ? pollValue.answer.table_description !== null && pollValue.answer?.table_description !== undefined
                    ? {
                        description: pollValue.answer?.table_description,
                        value: pollValue.answer.value
                    }
                    : { value: pollValue.answer?.value }
                : { description: pollValue.free_description || '' },
            time: date.toISOString(),
            id: pollValue.answer?.question?.inquiry_id,
            color_alert: pollValue.answer?.color_alert,
        };

        physiological.push(transformElement);
    });

    const timestamps = Array.from(new Set(
        physiological.map(element => moment(element.time).locale('es').format('DD-MM-YYYY HH:mm:ss'))
    )).sort(compareDates);

    const dataElements: DataElement[] = [];
    timestamps.forEach(date => {
        dataElements.push({ date, values: {}, comments: {}, colors: {} });
    });

    physiological.forEach(element => {
        const date = moment(element.time).format('DD-MM-YYYY HH:mm:ss');
        const position = dataElements.findIndex(dataElement => dataElement.date === date);

        if (position === -1) return;

        const sheetParameterID = OTHER_FC_EKG.includes(element.sheet_parameter_id ?? '') ? 'FC_EKG' : element.sheet_parameter_id;

        if (sheetParameterID === undefined) return;

        const currentValue = dataElements[position].values[sheetParameterID];
        const nextValue = valueOrNull(element.value);

        if (nextValue !== null || currentValue === undefined || currentValue === null) {
            dataElements[position].values[sheetParameterID] = nextValue;
        }

        if (
            dataElements[position].values[sheetParameterID + '_db_id'] === undefined ||
            dataElements[position].values[sheetParameterID + '_db_id'] === null
        ) {
            dataElements[position].values[sheetParameterID + '_db_id'] = element.id ?? null;
        }

        if (
            dataElements[position].values[sheetParameterID + '_user'] === undefined ||
            dataElements[position].values[sheetParameterID + '_user'] === null
        ) {
            dataElements[position].values[sheetParameterID + '_user'] = element.user_id ?? null;
        }

        if (element.sheet_parameter_option_id !== undefined && element.sheet_parameter_option_id !== null) {
            dataElements[position].comments[sheetParameterID + '_comment'] = element.sheet_parameter_option_id;
        }

        if (element.comment !== undefined && element.comment !== null && element.comment !== '') {
            dataElements[position].comments[sheetParameterID + '_comment'] = element.comment;
        }

        if (element.description !== undefined && element.description !== null && element.description !== '') {
            dataElements[position].comments[sheetParameterID + '_description'] = element.description;
        }

        if (element.color_alert) {
            dataElements[position].colors[sheetParameterID] = element.color_alert;
        }
    });

    return dataElements.filter(element => Object.keys(element.values).length > 0);
};

// parses the physiological monitornig data to PhysiologicalDataCase
export const parsePhysiologicalMontioringCases = (data: PhysiologicalMonitoring[], pollValues: PollValues[], cases_ids: number[]): PhysiologicalDataCase[] => {
    const physiologicalCases: PhysiologicalDataCase[] = [];

    cases_ids.forEach(case_id => {
        const inquiriyAnswersCase = pollValues.filter(poll => poll.assigned_inquiry?.case_id === case_id);
        const physiologicalCase = data.filter(timestampData => timestampData.case_id === case_id);

        const elements = parsePhysiologicalMontioring(physiologicalCase, inquiriyAnswersCase);

        physiologicalCases.push({ case_id, elements });
    });

    return physiologicalCases;
};